<template>
  <div>
    <!-- Section Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="text-center flex-grow-1">
        <h2 class="fw-bold text-primary mb-0" style="font-size: 1.75rem; letter-spacing: 0.5px;">
          🎓 Detailed Student View
        </h2>
        <p class="text-muted mb-0" style="font-size: 0.95rem;">
          Overview of student applications
        </p>
      </div>

      <!-- Danger Close Button -->
      <button type="button" class="btn btn-danger btn-sm ms-3" @click="closeWindow()">
        Close
      </button>
    </div>


    <!-- Toolbar: Select All & Move Button -->
    <div class="d-flex justify-content-between align-items-center mb-3 px-2">
      <!-- Select All Checkbox -->
      <div class="form-check">
        <input type="checkbox" class="form-check-input me-1" id="selectAllCheckbox" v-model="selectAll"
          @change="toggleSelectAll" />
        <label for="selectAllCheckbox" class="form-check-label text-dark" style="font-size: 0.9rem;">
          Select All
        </label>
      </div>

      <!-- Move to Programme Button (original style kept) -->
      <button @click="moveToProgramme" class="btn btn-primary" :disabled="selectedStudents.length === 0">
        Move to Programme
      </button>
    </div>


    <div class="table-responsive rounded">
      <table class="table table-striped table-bordered">
        <thead class="thead-dark text-left">
          <tr>
            <th rowspan="2" style="padding: 10px; border: 1px solid #ddd;">Student Name</th>
            <th v-if="admissionFormDetails.admissionformsections.length"
              :colspan="admissionFormDetails.admissionformsections.length" class="text-center">
              Sections
            </th>
          </tr>
          <tr v-if="admissionFormDetails.admissionformsections.length">
            <th v-for="section in admissionFormDetails.admissionformsections" :key="section.id"
              style="padding: 10px; border: 1px solid #ddd;">
              {{ section.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="application in admissionFormDetails.applications" :key="application.id">
            <td style="padding: 8px 10px; border: 1px solid #ddd;">
              <div class="d-flex flex-column">

                <!-- Top row: Checkbox, name, status icon, view icon -->
                <div class="d-flex align-items-center mb-1" style="gap: 6px;">
                  <input v-if="isStudentFullyApproved(application)" type="checkbox" v-model="selectedStudents"
                    :value="{ id: application.id, name: application.name, email: application.email }"
                    @change="toggleGoToClassButton" style="transform: scale(0.9);" />

                  <span class="fw-semibold text-dark" style="font-size: 0.85rem;">
                    {{ application.name }}
                  </span>

                  <!-- ✅ Green tick if ALL sections approved -->
                  <i v-if="isStudentFullyApproved(application)" class="fas fa-check-circle text-success"
                    style="font-size: 0.9rem;" title="All sections approved"></i>

                  <!-- <i @click="openStudentPopup(application)" class="fas fa-external-link-alt text-info"
    title="View Responses" style="cursor: pointer; font-size: 0.8rem;"></i> -->
                </div>

                <!-- Bottom row: Moved To Tag -->
                <span v-if="application.usergroup"
                  style="font-size: 0.65rem; padding: 2px 6px; background-color: #eaf7fb; color: #117a8b; border-radius: 4px; font-style: italic; font-weight: 500; display: inline-block;">
                  Moved To: {{ application.usergroup.name }}
                </span>
              </div>
            </td>

            <td v-for="section in admissionFormDetails.admissionformsections" :key="section.id"
              style="padding: 10px; border: 1px solid #ddd;">
              <div v-if="isSectionApproved(section, application.id)">
                <span class="text-success">Approved</span>
              </div>
              <div v-else>
                <span class="text-danger">Pending</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Move To Programme -->
    <b-modal v-model="showClassPopup" title="Move to Programme" size="md" hide-footer>
      <MoveToProgramme :publicusers="selectedStudents" @close="handleCloseClassPopup" />
    </b-modal>

  </div>
</template>

<script>
import MoveToProgramme from './moveToProgramme.vue';
export default {
  data() {
    return {
      // showPopup: false,
      admissionFormDetails: { admissionformsections: [], applications: [] },
      newQuestionsAnswerAttachments: {},
      uploadPercentage: {},
      userAttachments: null,
      selectedStudent: {},
      admissiondesk: false,
      adminrole_admissiondesk: false,
      verifiedAnswers: {},
      confirmQuestionId: null,
      confirmQuestionNo: null,
      confirmQuestionName: '',
      confirmAnswer: '',
      verifyAllBtn: false,
      editingQuestionId: null,
      verifyingQuestionId: null,
      modifiedAnswer: "",
      selectAll: false,
      selectedStudents: [],
      showClassPopup: false,
      oldAnswer: "",
      facultyOptions: [],
    };
  },

  components: { MoveToProgramme },

  async created() {
    this.admissiondesk = this.$route.params.admissiondesk === "true" || this.$route.query.admissiondesk === "true";
    this.adminrole_admissiondesk = this.$route.params.adminrole_admissiondesk === "true" || this.$route.query.adminrole_admissiondesk === "true";
    this.userAttachments = this.$store.getters.getAPIKey.userAttachments;
    await this.fetchInstitutionFaculties();
    await this.getAdmissionFormDetails();
  },

  watch: {
    selectedStudents(newVal) {
      const fullyApproved = this.admissionFormDetails.applications.filter(app => this.isStudentFullyApproved(app));
      this.selectAll = newVal.length === fullyApproved.length && fullyApproved.length > 0;
    }
  },

  methods: {
     isStudentFullyApproved(application) {
      if (!this.admissionFormDetails.admissionformsections.length) {
        return false; // No sections → can't be approved
      }

      // ✅ All sections must be approved for this student
      return this.admissionFormDetails.admissionformsections.every(section =>
        this.isSectionApproved(section, application.id)
      );
    },
    isSectionApproved(section, applicationId) {
      if (!section.approvers || section.approvers.length === 0) {
        return false; // No approvers → Pending
      }

      // Check if every approver has an approval with status "approved" for this application
      return section.approvers.every(approver => {
        const approval = approver.approvals.find(a => a.application_id === applicationId);
        return approval && approval.approval_status === 'approved' && approval.submit === 1;
      });
    },
    closeWindow() {
      window.close();
    },
    getFacultyName(id) {
      const faculty = this.facultyOptions.find(f => f.id === id);
      return faculty ? faculty.name.trim() : 'Unknown';
    },
    async fetchInstitutionFaculties() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionusers/faculties`;
      try {
        const response = await this.$axios.get(url);
        this.facultyOptions = response.data
          .filter(staff => staff.enroll_status === 'active')
          .map(staff => ({
            id: staff.id,
            name: `${staff.first_name} ${staff.last_name}`
          }));
      } catch (error) {
        console.error("Error fetching faculty data:", error);
      }
    },
    formatFileName(name) {
      // Optional: trim or shorten long names
      if (name.length > 30) {
        return name.slice(0, 25) + '...';
      }
      return name;
    },
    handleCloseClassPopup() {
      this.showClassPopup = false;
      this.selectAll = false;
      this.selectedStudent = {};
      this.selectedStudents = [];
      this.refreshPopup();
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedStudents = this.admissionFormDetails.applications
          .filter(app => this.isStudentFullyApproved(app)) // ✅ Only fully approved students
          .map(app => ({
            id: app.id,
            name: app.name,
            email: app.email,
          }));
      } else {
        this.selectedStudents = [];
      }
    },
    toggleGoToClassButton() {
      const verifiedCount = this.admissionFormDetails.applications.filter(app => app.verified).length;
      this.selectAll = this.selectedStudents.length === verifiedCount;
    },
    moveToProgramme() {
      if (this.selectedStudents.length > 0) {
        this.showClassPopup = true;
      }
    },
    newFileInputMask(questionId) {
      let elementReference = `${"newFileInput" + questionId}`;
      this.$refs[elementReference][0].$refs.input.click();
    },
    async newFileInput(file, questionId) {
      this.$set(this.newQuestionsAnswerAttachments, questionId, []);
      this.newQuestionsAnswerAttachments[questionId].push(file.name);

      this.$set(this.uploadPercentage, questionId, {});
      this.$set(this.uploadPercentage[questionId], "value", 0);

      let index = this.newQuestionsAnswerAttachments[questionId].indexOf(
        file.name
      );

      await this.uploadAttachment(file[0], questionId);

      await this.newQuestionsAnswerAttachments[questionId].splice(index, 1);

      this.getUplodedAnswer(questionId);
      // // this.initiateAdmissionForm();
    },
    async getUplodedAnswer() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/admissionformsapplications/${this.selectedStudent.id}/onlinereganswers`;
      try {
        const response = await this.$axios.get(url);
        response;
        // Fetch updated details
        await this.getAdmissionFormDetails();
        // Update selected student in the popup
        this.selectedStudent = this.admissionFormDetails.applications.find(app => app.id === this.selectedStudent.id) || {};
      } catch (error) {
        console.error("Error fetching uploaded answers:", error);
      } finally {
        this.fetchData = false; // Ensuring `fetchData` is set to false after API call
      }
    },
    async uploadAttachment(file, questionId) {
      let formData = await new FormData();

      await formData.append("question_id", questionId);
      await formData.append("answer", null);
      await formData.append(
        "application_id",
        this.selectedStudent.id
      );
      await formData.append("attachment", file);
      // await formData.append("file", file);

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/admissionformsanswers/attachmentanswer`;
      await this.$axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage[questionId].value = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          response;
        })
        .catch((error) => {
          error;
        });
      // file;
      // this.uploadPercentage[questionId]["value"] = await 50;
    },
    async deleteAnswerAttachment(fileId) {
      this.loadAnswer = true;

      const url = this.$store.getters.getAPIKey.mainAPI +
        `/admissionformsanswers/attachments/${fileId}`;

      try {
        await this.$axios.delete(url);

        this.$toast.success("Attachment Deleted.", {
          position: "top",
          duration: 3000,
        });

        // Fetch updated details
        await this.getAdmissionFormDetails();
        // Update selected student in the popup
        this.selectedStudent = this.admissionFormDetails.applications.find(app => app.id === this.selectedStudent.id) || {};
      } catch (error) {
        console.error("Error deleting attachment:", error);
        this.$toast.error("Failed to delete attachment.", {
          position: "top",
          duration: 3000,
        });
      } finally {
        this.loadAnswer = false;
      }
    },

    editAnswer(question) {
      this.editingQuestionId = question.id;
      this.verifyingQuestionId = null;
      const answerObj = this.selectedStudent.answers.find(ans => ans.question_id === question.id);
      this.modifiedAnswer = answerObj?.answer || "";
    },
    confirmModification(question) {
      const answerObj = this.selectedStudent.answers.find(ans => ans.question_id === question.id);
      this.oldAnswer = answerObj?.answer || "";
      this.confirmQuestionNo = question.question_no;
      this.confirmQuestionId = question.id;
      this.confirmQuestionName = question.name;
      this.confirmAnswer = this.modifiedAnswer;
      this.$bvModal.show('showConfirmPopup');
    },
    async submitModification() {
      try {
        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: this.selectedStudent.id,
          question_id: this.editingQuestionId,
          new_answer: this.modifiedAnswer,
          old_answer: this.oldAnswer,
          is_modify: true
        });

        this.$toast.success("Answer modified successfully", { position: "top-right", duration: 3000 });
        this.editingQuestionId = null;
        this.confirmQuestionNo = null;
        this.confirmQuestionId = null;
        this.confirmQuestionName = null;
        this.confirmAnswer = null;
        this.oldAnswer = null;
        this.showConfirmPopup = false;
        this.refreshPopup();
      } catch (error) {
        this.$toast.error("Modification failed!", { position: "top-right", duration: 3000 });
      }
    },
    async verifyAll() {
      const applicationId = this.selectedStudent.id;
      this.verifyAllBtn = true;

      const unverifiedAnswers = this.selectedStudent.answers
        ?.filter(answer => !answer.verified_at)
        .map(answer => answer.question_id);

      if (!unverifiedAnswers.length) {
        this.$toast.info("All answers are already verified", { position: "top-right", duration: 3000 });
        this.verifyAllBtn = false;
        return;
      }

      try {
        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: applicationId,
          question_ids: unverifiedAnswers,  // Send all question IDs in one request
          is_verify: true,
          verify_all_answers: true
        });

        this.$toast.success("All unverified answers have been verified", { position: "top-right", duration: 3000 });
        this.refreshPopup();
      } catch (error) {
        this.$toast.error("Verification failed! Please try again.", { position: "top-right", duration: 3000 });
        console.error("Error verifying answers:", error);
      }

      this.verifyAllBtn = false;
    },

    isVerified(questionId) {
      const answerObj = this.selectedStudent.answers?.find(ans => ans.question_id === questionId);
      return answerObj?.verified_at && answerObj?.verified_by;
    },

    getVerifiedBy(questionId) {
      const answerObj = this.selectedStudent.answers.find(
        ans => ans.question_id === questionId
      );

      if (!answerObj?.verified_by || !answerObj?.verified_at) return null;

      const formattedDate = new Date(answerObj.verified_at).toLocaleDateString('en-GB'); // dd/mm/yyyy format
      return `${answerObj.verified_by} - ${formattedDate}`;
    },

    getModifiedBy(questionId) {
      const answerObj = this.selectedStudent?.answers?.find(
        ans => ans.question_id === questionId
      );

      if (!answerObj?.modification_details) return null;

      return `${answerObj.modification_details}`;
    },


    getAnswer(answers, questionId) {
      return answers?.find(ans => ans.question_id === questionId)?.answer || "";
    },

    getUploads(answers, questionId) {
      return answers?.find(ans => ans.question_id === questionId)?.files || [];
    },

    async getAdmissionFormDetails() {
      const admissionformId = this.$route.params.admissionform_id;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/${admissionformId}`;

      try {
        const { data } = await this.$axios.get(url);
        this.admissionFormDetails = {
          ...data,
          admissionformsections: data.admissionformsections,
          applications: data.applications
            .filter(app => app.end_at !== null),
        };
      } catch (error) {
        console.error("Error fetching admission form details:", error);
      }
    },

    // openStudentPopup(student) {
    //   this.selectedStudent = student;
    //   this.showPopup = true;
    //   this.refreshPopup();
    // },

    async confirmVerification(question) {
      this.verifyingQuestionId = question.id;
      this.editingQuestionId = null; // Disable editing during verification
      this.confirmQuestionId = question.id;
      await this.verifyAnswer();
      this.refreshPopup();
    },

    async verifyAnswer() {
      const application = this.selectedStudent;
      this.$set(this.verifiedAnswers, this.confirmQuestionId, true);

      try {
        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: application.id,
          question_id: this.confirmQuestionId,
          is_verify: true,
        });

        this.$toast.success("Verified", { position: "top-right", duration: 3000 });
      } catch (error) {
        console.error("Error verifying answer:", error);
      }
    },
    async refreshPopup() {
      // Fetch updated details
      await this.getAdmissionFormDetails();
      // Update selected student in the popup
      this.selectedStudent = this.admissionFormDetails.applications.find(app => app.id === this.selectedStudent.id) || {};
      this.editingQuestionId = null;
      this.verifyingQuestionId = null;
      this.confirmQuestionNo = null;
      this.confirmQuestionId = null;
      this.confirmQuestionName = null;
      this.confirmAnswer = null;
      this.$bvModal.hide('showConfirmPopup');
      this.$forceUpdate(); // Ensure Vue updates the component
    }
  },
};
</script>
<style scoped>
.uploaded-files {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.file-item {
  font-size: 14px;
}

.file-link {
  color: #007bff;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}

.file-link:hover {
  text-decoration: underline;
  color: #0056b3;
}

.file-link i {
  color: #555;
}
</style>